import React from 'react';
import { Route } from 'react-router';
import { Redirect } from 'react-router-dom';
import { hasCookie } from '../../utils/cookieUtil';
import { store } from '../../index.js';

const UnAuthenticatedRoute = ({ component: Component, ...rest }) => {
  const isAllow = (locationUrl) => {
    if(locationUrl=="/" || locationUrl=="/login"){
      // has already logged in
      if (hasCookie()) {
        return false;
      }
    }
    return true;
  };

  return (
    <Route {...rest} render={(props) => (
      isAllow(props.location.pathname) === true ?
        <Component {...props} /> 
        :<Redirect to={{
          pathname: '/processmanagement',
          state: { from: props.location }
        }}/>
    )} />
  );
};

export default UnAuthenticatedRoute;
